<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <p @click="$router.go(-1)" class="back">back</p>
      <md-card>
        <md-card-content v-if="contractor" class="md-layout md-gutter">
          <div class="clicks">
            <div class="click">
              <p>
                Requests Sent
                <span>{{ clicks }}</span>
              </p>
            </div>
          </div>
        </md-card-content>
      </md-card>

      <md-card>
        <md-card-content v-if="contractor" class="md-layout md-gutter">
          <h3>Address</h3>
          <div class="md-layout-item md-size-50">
            <md-field>
              <vue-google-autocomplete
                types=""
                id="input_address"
                class="md-layout-item md-size-100"
                classname="form-control"
                placeholder="Address 1"
                v-on:placechanged="setInput_address"
                v-model="contractor.address.address_1"
                v-on:error="handleError"
              >
              </vue-google-autocomplete>
              <span class="md-helper-text"
                >Required, Must choose a google verified address.</span
              >
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Address 2</label>
              <md-input
                v-model="contractor.address.address_2"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Address 3</label>
              <md-input
                v-model="contractor.address.address_3"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Zip</label>
              <md-input v-model="contractor.address.zip" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>City</label>
              <md-input
                v-model="contractor.address.city"
                type="text"
              ></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>State</label>
              <md-input
                v-model="contractor.address.state"
                type="text"
              ></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Country</label>
              <md-input
                v-model="contractor.address.country"
                type="text"
              ></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>

          <div class="divider"></div>
          <h3>Details</h3>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Name</label>
              <md-input v-model="contractor.name" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Short Description</label>
              <md-input
                v-model="contractor.short_description"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Long Description</label>
              <md-textarea
                v-model="contractor.long_description"
                type="text"
              ></md-textarea>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Phone</label>
              <md-input
                v-model="contractor.contact_info.phone"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Email</label>
              <md-input
                v-model="contractor.contact_info.email"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Fax</label>
              <md-input
                v-model="contractor.contact_info.fax"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Website</label>
              <md-input v-model="contractor.website" type="text"></md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-50">
            <div class="input">
              <label>Location Images (Upload up to 4 Images)</label>
              <upload
                multiple
                title="Images"
                :media="contractor.url"
                @addMedia="addMedia($event, 'media')"
                @removeMedia="removeMedia($event, 'media')"
                @removeImage="contractor.event_image = null"
              ></upload>
            </div>
          </div>

          <div class="md-layout-item md-size-50">
            <div class="input">
              <div class="imgs">
                <div
                  class="img"
                  :key="img"
                  v-for="(img, i) in contractor.media"
                >
                  <div @click="removeMedia(i)" class="del-img">x</div>
                  <img :src="img" />
                </div>
              </div>
            </div>
          </div>

          <div class="divider"></div>
          <h3>Hours of Operation</h3>
          <div class="md-layout-item md-size-50 times">
            <md-field>
              <label>Add in a custom line</label>
              <md-input
                v-model="hour"
                type="text"
                placeholder="Monday - Friday: 9:00am - 4:00pm"
              ></md-input>
              <md-button class="md-primary md-round md-small" @click="addHour()"
                >Add</md-button
              >
            </md-field>
          </div>

          <div
            class="md-layout-item md-size-50 times"
            v-for="(time, i) in hours"
          >
            <md-field>
              <md-input
                v-model="hours[i]"
                type="text"
                placeholder="Monday - Friday: 9:00am - 4:00pm"
              ></md-input>
              <md-button
                class="md-primary md-round md-small remove"
                @click="removeHour(i)"
                >remove</md-button
              >
            </md-field>
          </div>

          <div class="divider"></div>
          <h3>Filters</h3>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Activity Types</label>
              <md-select multiple v-model="contractor.activity_types">
                <md-option value="activity">ACTIVITY</md-option>
                <md-option value="dining">DINING</md-option>
              </md-select>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Should appear on devices in the following stores</label>
              <md-select v-model="contractor.approved_stores" multiple>
                <md-option v-for="s in stores" :key="s.id" :value="s.id">{{
                  s.name
                }}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Services Offered</label>
              <md-select v-model="contractor.services" multiple>
                <md-option v-for="s in services" :key="s.id" :value="s.id">{{
                  s.name
                }}</md-option>
              </md-select>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Status</label>
              <md-select v-model="contractor.status">
                <md-option value="ACTIVE">Active</md-option>
                <md-option value="DISABLED">Disabled</md-option>
              </md-select>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label
                >Accept jobs within {{ contractor.accept_radius }} miles</label
              >
              <md-input
                v-model="contractor.accept_radius"
                type="text"
              ></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-datepicker
              v-model="contractor.startDate"
              :md-model-type="Number"
            >
              <label>Start date</label>
            </md-datepicker>
          </div>
          <div class="md-layout-item md-size-50">
            <md-datepicker v-model="contractor.endDate" :md-model-type="Number">
              <label>End date</label>
            </md-datepicker>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <md-button class="md-primary md-round md-small" @click="validate()"
            >Save</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<!-- import google places api -->
<script
  src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAhumEs_cAeJngaTPxtCYpXWuYMpc5fNPg&libraries=places&callback=initAutocomplete"
  async
  defer
></script>

<script>
import Fuse from "fuse.js";
import { db } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import Upload from "@/components/Inputs/UploadMult.vue";

export default {
  components: {
    Upload,
    VueGoogleAutocomplete
  },
  data() {
    return {
      batch: db.batch(),
      contractor: {
        name: "",
        short_description: "",
        long_description: "",
        status: "ACTIVE",
        rating_quality: 0,
        rating_price: 0,
        website: null,
        startDate: Date.now(),
        endDate: null,
        contact_info: {
          phone: "",
          fax: "",
          email: "",
          contacts: []
        },
        address: {
          address_1: "",
          address_2: "",
          address_3: "",
          zip: "",
          city: "",
          state: "",
          country: "",
          coords: {
            lat: "",
            lng: ""
          }
        },
        media: null,
        activity_types: [],
        approved_stores: [],
        services: [],
        accept_radius: 50
      },
      hours: [],
      hour: null,
      stores: [],
      services: [],
      clicks: null
    };
  },
  firestore() {
    return {
      stores: db.collection("store"),
      services: db
        .collection("preset_user_menus")
        .doc("service_menu")
        .collection("services")
    };
  },
  created() {
    this.getClicks();
    let contractorId = this.$route.params.contractor_id;
    let contractorTemplate = Object.assign({}, this.contractor);
    this.approvedStoresCalled = false;
    this.serviceCalled = false;
    return this.$bind(
      "contractor",
      db.collection("contractor").doc(contractorId)
    ).then(snap => {
      if (!this.contractor) {
        this.contractor = contractorTemplate;
      }
      if (this.contractor.hours) {
        this.hours = this.contractor.hours;
      }
    });
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "url"],
      threshold: 0.3
    });
  },
  methods: {
    getClicks() {
      db.collection("contractor")
        .doc(this.$route.params.contractor_id)
        .collection("requests")
        .get()
        .then(snapshot => {
          this.clicks = snapshot.docs.length;
        });
    },
    removeHour(i) {
      this.hours.splice(i, 1);
    },
    addHour() {
      if (this.hours) {
        this.hours.unshift(this.hour);
      } else {
        this.hours = [];
        this.hours.push(this.hour);
      }
      this.hour = null;
    },
    addMedia(url, key) {
      if (!this.contractor.media) {
        this.contractor.media = [];
      }
      if (this.contractor.media.length < 4) {
        this.contractor.media.push(url);
      } else {
        console.log("Uploading too many Images");
      }
    },
    removeMedia(i) {
      this.contractor.media.splice(i, 1);
    },
    validate() {
      let valid = true;
      for (let k in this.contractor) {
        if (
          !this.contractor[k] &&
          k != "clicks" &&
          k != "long_description" &&
          k != "short_description" &&
          k != "rating_price" &&
          k != "rating_quality" &&
          k != "work_types" &&
          k != "website" &&
          k != "startDate" &&
          k != "endDate" &&
          k != "rating" &&
          k != "media"
        ) {
          valid = false;
          console.log(k);
        }

        if (
          Array.isArray(this.contractor[k]) &&
          this.contractor[k].length < 1 &&
          k != "work_types" &&
          k != "approved_stores" &&
          k != "hours"
        ) {
          valid = false;
          console.log(k);
        }
      }

      for (let k in this.contractor.address) {
        if (
          !this.contractor.address[k] &&
          k != "address_2" &&
          k != "address_3" &&
          k != "zip" &&
          k != "city" &&
          k != "state" &&
          k != "coords"
        ) {
          valid = false;
          console.log(k);
        }
      }

      for (let k in this.contractor.contact_info) {
        if (
          !this.contractor.contact_info[k] &&
          k != "contacts" &&
          k != "fax" &&
          k != "phone" &&
          k != "email"
        ) {
          valid = false;
          console.log(k);
        }
      }

      if (valid) {
        this.save();
      } else {
        return Swal.fire("Missing Fields", "Please enter all required fields");
      }
    },
    save() {
      let vm = this;
      if (this.contractor && !this.contractor.created) {
        this.contractor.created = new Date();
        this.contractor.clicks = 0;
      }
      this.contractor.hours = this.hours;
      return db
        .collection("contractor")
        .doc(this.$route.params.contractor_id)
        .set(vm.contractor, { merge: true })
        .then(() => {
          this.batch.commit();
        })
        .then(() => {
          this.batch = db.batch();
          Swal.fire("Success", "Page Updated", "success").then(() => {
            this.$router.go(-1);
          });
        });
    },
    updateGalleries(ref, data) {
      if (data === null) {
        this.batch.delete(ref);
      } else {
        this.batch.set(ref, data, { merge: true });
      }
    },
    setInput_address(input_address, placeResultData, id) {
      console.log(placeResultData);
      console.log(input_address);
      this.contractor.place_id = placeResultData.place_id;
      if (placeResultData.opening_hours) {
        if (placeResultData.opening_hours.weekday_text) {
          this.hours = [];
          placeResultData.opening_hours.weekday_text.forEach(time => {
            this.hours.push(time);
          });
        }
      }
      this.contractor.directions = placeResultData.url;
      if (placeResultData.website) {
        this.contractor.website = placeResultData.website;
      }
      this.contractor.name = placeResultData.name;
      if (placeResultData.rating) {
        this.contractor.rating = placeResultData.rating;
      }
      if (placeResultData.photos) {
        let max =
          placeResultData.photos.length > 4 ? 4 : placeResultData.photos.length;
        this.contractor.media = placeResultData.photos
          .slice(0, max)
          .map(img => {
            return img.getUrl();
          });
      }
      this.input_address = input_address;
      if (
        this.input_address.street_number == null &&
        this.input_address.route == null &&
        this.input_address.postal_code == null
      ) {
        this.contractor.address.address_1 = "";
      } else if (
        this.input_address.street_number == null &&
        this.input_address.route == null
      ) {
        this.contractor.address.address_1 = document.getElementById(
          "input_address"
        ).value;
      } else if (this.input_address.street_number == null) {
        this.input_address.route == null;
      } else if (this.input_address.route == null) {
        this.input_address.street_number == null;
      } else {
        this.contractor.address.address_1 =
          this.input_address.street_number + " " + this.input_address.route;
      }
      this.contractor.address.address_1 = document.getElementById(
        "input_address"
      ).value;
      this.contractor.address.zip = this.input_address.postal_code;
      //for city and state the to access the information I had to dig in a little bit into placeResultData
      if (input_address.locality) {
        this.contractor.address.city = input_address.locality;
      }
      this.contractor.address.state = input_address.administrative_area_level_1;
      this.contractor.address.country = this.input_address.country;
      this.contractor.address.coords.lat = this.input_address.latitude;
      this.contractor.address.coords.lng = this.input_address.longitude;
      console.log("this location", this.contractor.address);
    },
    handleError(error) {
      alert(error);
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

h3 {
  font-weight: bold;
  padding-left: 15px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 30px;
}

.imgs {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.imgs img {
  height: auto;
  max-height: 100%;
  border: 1px solid #eaeaea;
}

.imgs .img {
  position: relative;
  width: 49%;
  margin-bottom: 10px;
}

.imgs .img .del-img {
  position: absolute;
  background: #f44336;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 25px;
  top: 0;
  right: 0;
  color: white;
  font-weight: bold;
  cursor: pointer;
  font-size: 18px;
}


.times label {
  margin-left: 0;
  font-size: 14px;
  top: -20px;
  color: black !important;
  opacity: 1;
}

.times .md-button{
  padding: 0px;
  min-width: auto;
  margin-top: -1px;
}

.times .md-button .md-ripple {
  padding: 10px 25px;
}

.times .md-button.remove {
  background-color: transparent !important;
  box-shadow: none !important;
}

.times .md-button.remove .md-ripple {
  box-shadow: none !important;
  color: #f44336 !important;
}

.times .md-field {
  margin-bottom: 0px;
}

.click p  {
  font-weight: bolder;
}

.click p span {
  display: block;
  font-size: 50px;
  font-weight: normal;
  margin-top: 10px;
}
</style>
